<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-text-field v-model="data['name']" box label="Flow Name" />
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AddFlowForm',
  props: ['data']
};
</script>

<style scoped></style>
